import React, { useEffect, useState } from 'react';
import Script from 'next/script';
import { getBaseDomain } from '../utils/helpers';
import { useMiscellaneousData } from '../contexts/ssr-miscellaneous-context';

const GTM_ID = {
  nextias: 'GTM-P3XT2KB',
  madeeasy: 'GTM-NT26XPW',
};

function GoogleTagManager() {
  const { miscellaneousData } = useMiscellaneousData();
  const [mounted, setMounted] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => {
      setMounted(true);
    }, 100);

    return () => clearTimeout(timer);
  }, []);

  useEffect(() => {
    if (mounted && typeof window !== 'undefined') {
      const orgDomain = getBaseDomain(miscellaneousData?.hostname);
      const gtmId = orgDomain === 'nextias' ? GTM_ID.nextias : GTM_ID.madeeasy;

      // Initialize dataLayer
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        'gtm.start': new Date().getTime(),
        event: 'gtm.js',
        organization: orgDomain,
      });

      // Inject GTM script
      const script = document.createElement('script');
      script.innerHTML = `
        (function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
        new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
        j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
        'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
        })(window,document,'script','dataLayer','${gtmId}');
      `;
      document.head.appendChild(script);

      // Inject noscript iframe
      const noscript = document.createElement('noscript');
      const iframe = document.createElement('iframe');
      iframe.src = `https://www.googletagmanager.com/ns.html?id=${gtmId}`;
      iframe.height = '0';
      iframe.width = '0';
      iframe.style.display = 'none';
      iframe.style.visibility = 'hidden';
      noscript.appendChild(iframe);
      document.body.insertBefore(noscript, document.body.firstChild);
    }
  }, [mounted, miscellaneousData?.hostname]);

  return null;
}

export default GoogleTagManager;
